import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import MixerAndProportionInformationBindScreen from './screens/MixerAndProportionInformationBindScreen';

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: <MixerAndProportionInformationBindScreen />,
  },
];

const MixerAndProportionInformationBindRouter = () => PermissionRoute(routesConfig);

export default memo(MixerAndProportionInformationBindRouter);
